import { increaseHoursInDate } from 'utils/dates'

const { z } = require('zod')

export const ClinicalAssistanceSchema = (accidentType) =>
	z.object({
		clinicalAssistance: z
			.object({
				injuredHasClinicalAssistance: z.boolean(),
				injuredHospitalized: z.boolean().optional(),
				injuredHospitalizedReason: z.number().optional(),
				injuredHospitalizedOtherReason: z.string().optional(),
				service: z.string().optional(),
				floor: z.string().optional(),
				bed: z.string().optional(),
				dischargeForecast: z.boolean().optional(),
				dischargeForecastDate: z
					.string()
					.transform((date) =>
						date ? increaseHoursInDate(date, 12) : ''
					)
					.optional(),
				hasStoppedWorking: z.boolean().optional(),
				hasStoppedWorkingSinceDate: z
					.string()
					.transform((date) =>
						date ? increaseHoursInDate(date, 12) : ''
					)
					.optional(),
				hasStoppedWorkingUntilDate: z
					.string()
					.transform((date) =>
						date ? increaseHoursInDate(date, 12) : ''
					)
					.optional()
					.nullable(),
				isClinicalDocumentationAttached: z.boolean().optional(),
			})
			.optional()
			.superRefine((data, ctx) => {
				if (data?.injuredHasClinicalAssistance !== undefined) {
					if (data?.injuredHasClinicalAssistance) {
						if (data?.injuredHospitalized === undefined) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: [
									'clinicalAssistance',
									'injuredHospitalized',
								],
							})
						}
					}

					if (data?.injuredHospitalized !== undefined) {
						if (
							data?.isClinicalDocumentationAttached === undefined
						) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: [
									'clinicalAssistance',
									'isClinicalDocumentationAttached',
								],
							})
						}
					}

					if (data.injuredHospitalized) {
						if (data?.injuredHospitalizedReason === undefined) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: [
									'clinicalAssistance',
									'injuredHospitalizedReason',
								],
							})
						}

						if (
							data?.injuredHospitalizedReason === 4 &&
							data?.injuredHospitalizedOtherReason === undefined
						) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: [
									'clinicalAssistance',
									'injuredHospitalizedOtherReason',
								],
							})
						}

						if (data?.service === undefined) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: ['clinicalAssistance', 'service'],
							})
						}
						if (data?.floor === undefined) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: ['clinicalAssistance', 'floor'],
							})
						}
						if (data?.bed === undefined) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: ['clinicalAssistance', 'bed'],
							})
						}

						if (data?.dischargeForecast === undefined) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: [
									'clinicalAssistance',
									'dischargeForecast',
								],
							})
						}

						if (
							data?.dischargeForecast &&
							data?.dischargeForecastDate === undefined
						) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: [
									'clinicalAssistance',
									'dischargeForecastDate',
								],
							})
						}
					}

					if (accidentType !== 'AD') {
						if (data?.hasStoppedWorking === undefined) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: [
									'clinicalAssistance',
									'hasStoppedWorking',
								],
							})
						}
						if (
							data?.hasStoppedWorking &&
							data?.hasStoppedWorkingSinceDate === undefined
						) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: [
									'clinicalAssistance',
									'hasStoppedWorkingSinceDate',
								],
							})
						}
					} else {
						if (data?.hasStoppedWorking === undefined) {
							ctx.addIssue({
								code: z.ZodIssueCode.custom,
								message: 'Required',
								path: [
									'clinicalAssistance',
									'hasStoppedWorking',
								],
							})
						}
					}
				}
			}),
	})

export const OptionalClinicalAssistanceSchema = z.object({
	clinicalAssistance: z
		.object({
			injuredHasClinicalAssistance: z.boolean().optional(),
			injuredHospitalized: z.boolean().optional(),
			injuredHospitalizedReason: z.number().optional(),
			injuredHospitalizedOtherReason: z.string().optional(),
			service: z.string().optional(),
			floor: z.string().optional(),
			bed: z.string().optional(),
			dischargeForecast: z.boolean().optional(),
			dischargeForecastDate: z
				.string()
				.transform((date) =>
					date ? increaseHoursInDate(date, 12) : ''
				)
				.optional(),
			hasStoppedWorking: z.boolean().optional(),
			hasStoppedWorkingSinceDate: z
				.string()
				.transform((date) =>
					date ? increaseHoursInDate(date, 12) : ''
				)
				.optional(),
			hasStoppedWorkingUntilDate: z
				.string()
				.transform((date) =>
					date ? increaseHoursInDate(date, 12) : ''
				)
				.optional(),
			isClinicalDocumentationAttached: z.boolean().optional(),
		})
		.optional(),
})
